module.exports = __webpack_public_path__ + "static/media/contacts1.7645df0b.png";